import Stack from 'components/elements/Stack'
import DownloadButton from 'components/modules/SEO/DownloadBanner'
import { getCountryLanguageConfig } from 'lib/constants/countryLanguageConfig'
import { useRouter } from 'next/router'
import { Headline4 } from 'stories/elements/Typography/Text'
import theme from 'stories/utils/theme'
import FeatureNotAvailableImage from 'assets/app/download/feature_not_available.webp'
import styled from 'styled-components'
import useMedia from 'lib/hooks/useMedia'
import { deviceSize } from 'lib/constants/GridBreakpoints'
import DownloadQRCode from '../widgets/QRCode'
import _useTranslation from 'lib/hooks/_useTranslation'
import { getMobileOS } from 'lib/tracking/attribution/device'

const Container = styled.section`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 50px;
    .button {
        width: 300px;
    }
`

const FeatureNotAvailable = () => {
    const { locale } = useRouter()
    const countryLanguageConfig = getCountryLanguageConfig(locale)
    const mobileOS = getMobileOS() ?? 'ios'
    const md = useMedia(deviceSize.md)
    const { t } = _useTranslation('app')

    return (
        <Container>
            {!countryLanguageConfig?.isLaunched ? (
                <>
                    <Headline4 color={theme.colors.backgroundSecondary} textAlign="center">
                        {t('app/featureNotAvailableTitle')}
                    </Headline4>
                    <img
                        src={FeatureNotAvailableImage.src}
                        width={FeatureNotAvailableImage.width}
                        height={FeatureNotAvailableImage.height}
                    />
                </>
            ) : (
                <>
                    <Headline4 color={theme.colors.backgroundSecondary} textAlign="center">
                        {t('app/downloadAppToUseThisFeatureTitle')}
                    </Headline4>
                    {md ? (
                        <DownloadButton type={mobileOS} referrerScreen="feature-not-available" isDark />
                    ) : (
                        <>
                            <div style={{ border: '3px solid white', borderRadius: '5px' }}>
                                <DownloadQRCode
                                    referrerScreen="webapp-feature-not-available-qr-code"
                                    codeColor={theme.colors.headlineDark}
                                />
                            </div>
                            <Stack>
                                <DownloadButton type="android" referrerScreen="feature-not-available" isDark />
                                <DownloadButton type="ios" referrerScreen="feature-not-available" isDark />
                            </Stack>
                        </>
                    )}
                    {/* <img src={DownloadAppImage.src} width={DownloadAppImage.width} height={DownloadAppImage.height} /> */}
                </>
            )}
        </Container>
    )
}

export default FeatureNotAvailable
